import React, { useState } from 'react';
import { css } from '@emotion/react';
import { IconButton, Menu, MenuItem, ListItemText, Tooltip } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import { greens, greys } from '@/styles/colors';

const OptionFilter = ({ value, onChange, options }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = !!anchorEl;

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleSelect = (val) => () => {
        onChange(val);
        handleClose();
    };

    const selected = options.find((o) => o.value === value);
    const tooltip = selected ? `Filtered: ${selected.label}` : 'Filter';

    return (
        <>
            <Tooltip title={tooltip} placement="top">
                <IconButton size="small" onClick={handleOpen}>
                    <FilterList
                        css={css`
                            color: ${value ? greens.primary : greys[2]};
                            font-size: 18px;
                        `}
                    />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                getContentAnchorEl={null}
            >
                <MenuItem onClick={handleSelect(null)} selected={!value} dense>
                    <ListItemText primary="All" />
                </MenuItem>
                {options.map((opt) => (
                    <MenuItem key={opt.value} onClick={handleSelect(opt.value)} selected={value === opt.value} dense>
                        <ListItemText primary={opt.label} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default OptionFilter;
